/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-expressions */
import {
  CSSResult, html, LitElement, unsafeCSS,
} from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import arrowRight from '@breuni-ui/nui/dist/design-tokens/images/icons/nui-arrow_chevron_right_direction=right_size=18_weight=regular.svg';
import styles from './hva.scss';
import { HvaModalModel } from './hva-modal-model.js';

@customElement('ents-hva-custom-select')
export class HvaCustomSelect extends LitElement {
  @property({ type: Object, reflect: false }) protected hvaModalModel! : HvaModalModel;

  @state() private open = false;

  @state() private usesPointerEvents = false;

  @state() private timer?: number;

  // use this syntax to make it work in Safari 14
  // working: static get styles() { return css`...` }
  // not working: static styles = css`...`
  static get styles(): CSSResult {
    return unsafeCSS(styles);
  }

  private toggleCustomSelect(e: PointerEvent | MouseEvent) {
    if (e instanceof PointerEvent) {
      this.usesPointerEvents = true;
    }
    if (this.open) {
      this.resetScrollPosition();
    }
    this.open = !this.open;
  }

  private resetScrollPosition() {
    const customSelect = this.shadowRoot?.querySelector('#ents-custom-hva-select-list');
    if (customSelect) {
      customSelect.scrollTop = 0;
    }
  }

  private onLeave() {
    // prevent 'pointerleave' events from closing the dropdown immediately (e.g. MS Surface)
    if (this.usesPointerEvents) {
      return;
    }
    this.timer = window.setTimeout(() => {
      this.resetScrollPosition();
      this.open = false;
    }, 150);
  }

  private onEnter() {
    if (this.timer) {
      window.clearTimeout(this.timer);
    }
  }

  private selectOption(value: number) {
    this.dispatchEvent(new CustomEvent('change', { detail: { selected: value } }));
    this.open = false;
  }

  protected render() {
    return html`
      <div class="ents-hva__haus-select__select ents-hva__haus-select__select--desktop">
        <div class="ents-hva__select ${classMap({ 'ents-hva__select--active': this.open })}">
          <div class="ents-prose-copy ents-hva__select__text" @click="${this.toggleCustomSelect}"
               @mouseenter="${this.onEnter}" @mouseleave="${this.onLeave}" data-test-ents-hva-haus-select-desktop>
            <span data-test-ents-hva-selected-haus>${this.hvaModalModel.getSelectedOptionNameOrPlaceholder()}</span>
            ${arrowRight()}
          </div>
          <div class="ents-hva__select__list" id="ents-custom-hva-select-list" @mouseenter="${this.onEnter}" @mouseleave="${this.onLeave}">
            ${this.hvaModalModel.getOptions(false).map(optionModel => html`
              <div class="ents-hva__select__list__option" key="${optionModel.value}"
                   @click="${() => this.selectOption(optionModel.value)}"
                   data-test-ents-hva-haus-select-item="${optionModel.value}">${optionModel.name}</div>
            `)}
          </div>
        </div>
      </div>
    `;
  }
}
